module.exports = __webpack_public_path__ + "img/valentines-day.png";